import {CustomCode} from "../../model/common.model";

export class CommunicationType extends CustomCode{
  public static _registered = new Map<string, CommunicationType>();
  static EMAIL = new CommunicationType('EMAIL');
  static PHONE = new CommunicationType('PHONE');
  static DEVICE_NOTIFICATION = new CommunicationType('DEVICE_NOTIFICATION');
  static ALL = Array.from(CommunicationType._registered.values());

  constructor(code: string) {
    super(code);
    CommunicationType._registered.set(code, this);
  }
  static retrieveFromCode(code: string): CommunicationType {
    const res = CommunicationType._registered.get(code);
    if (!res) {
      console.log('CommunicationType can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  public toTranslateKey(): string{
    return 'COMMUNICATION_TYPE_' + this.code;
  }



}
